module.exports = __webpack_public_path__ + "img/status-promotion.3cb28b62.png";